const msgTypes = {
    MARKET_ANALYSIS: 0,
    GENERAL: 1,
    PROMOTIONS: 2
}

export {
    msgTypes
}